export default "__VITE_ASSET__BfAB84W4__ 640w, __VITE_ASSET__DTPU0jsu__ 1024w, __VITE_ASSET__Cq1wY6rM__ 1920w";